import axios from "axios";
import { resolveBackendUrl } from "./apiOrigin";

const configuredBackendUrl = process.env.NODE_ENV === "development"
  ? process.env.REACT_APP_BACKEND_URL
  : "https://aramfix.nl";
const backendUrl = resolveBackendUrl(configuredBackendUrl, typeof window === "undefined" ? null : window.location.origin);
if (!backendUrl) throw new Error("REACT_APP_BACKEND_URL ontbreekt");

export const API = `${backendUrl}/api`;
export const api = axios.create({ baseURL: API, timeout: 30000 });

export const authHeaders = () => {
  const token = localStorage.getItem("aramfix-token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};